import PropTypes from 'prop-types';

const {FmlxAlert} = require('fmlx-common-ui');

function FastBanner({severity, title, textAlign}) {
  return <FmlxAlert severity={severity} title={title} textAlign={textAlign} />;
}

export default FastBanner;

FastBanner.propTypes = {
  severity: PropTypes.oneOf(Object.values(FmlxAlert.Severity)),
  title: PropTypes.string,
  textAlign: PropTypes.oneOf(Object.values(FmlxAlert.TextAlign)),
};

FastBanner.defaultProps = {
  severity: FmlxAlert.Severity.INFO,
  title: '',
  textAlign: FmlxAlert.TextAlign.CENTER,
};
